module.exports = __webpack_public_path__ + "static/media/white_add_prodOLD.855fbbcb.png";